import { useEffect, useState } from "react";
import Header from "../../Components/Header";
import SidePanel from "../../Components/SidePanel";
import { useDispatch, useSelector } from "react-redux";
import {
  UNIVERSITY_IMAGE_DETAILS_AC_UNIVERSITY,
  UNIVERSITY_IMAGE_DETAILS_AC_UNIVERSITY_RESET,
  UNIVERSITY_IMAGE_UPLOAD,
  UNIVERSITY_IMAGE_UPLOAD_RESET,
} from "../../Actions/universityImageUploadAction";
import {
  Image_Upload_Form_Check,
  Image_Upload_Form_Model,
} from "../../Models/UniversityImageUploadModel";

export default function UniversityImageUpload() {
  const [hideSidepanel, setHideSidePanel] = useState(true);
  const [Error, setError] = useState([]);
  const [University_List, setUniversity_List] = useState([]);
  const [UniversityImageUpload_Form, setUniversityImageUpload_Form] = useState(
    Image_Upload_Form_Model
  );
  const [ImageType, setImageType] = useState("");
  const dispatch = useDispatch();

  const { UniversityList, university_list_Error } = useSelector(
    (state) => state.UNIVERSITY_LIST_REDUCER
  );

  //-----------------------------------------------------------------//

  const {
    University_Image_Ac_Type_Loading,
    University_Image_Ac_Type,
    University_Image_Ac_Type_Error,
  } = useSelector(
    (state) => state.UNIVERSITY_IMAGE_DETAILS_AC_UNIVERSITY_REDUCER
  );

  //-----------------------------------------------------------------//

  const {
    Upload_University_Images_Loading,
    Upload_University_Images_Success,
    Upload_University_Images_Error,
  } = useSelector((state) => state.UNIVERSITY_IMAGE_UPLOAD_REDUCER);

  const handleHide = (e) => {
    e.preventDefault();
    setHideSidePanel(!hideSidepanel);
  };

  //-----------------------------------------------------------------//

  const handleChange = (e) => {
    if (e.target.name === "universityfile") {
      setUniversityImageUpload_Form({
        ...UniversityImageUpload_Form,
        [e.target.name]: e.target.files[0],
      });
    } else {
      setUniversityImageUpload_Form({
        ...UniversityImageUpload_Form,
        [e.target.name]: e.target.value,
      });
    }
    if (e.target.name === "University_Id") {
      dispatch(UNIVERSITY_IMAGE_DETAILS_AC_UNIVERSITY(e.target.value));
    }
    setError([]);
  };

  //-----------------------------------------------------------------//

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const Form_Check = Image_Upload_Form_Check(
      UniversityImageUpload_Form,
      ImageType
    );
    if (Form_Check[0] === "success") {
      dispatch(UNIVERSITY_IMAGE_UPLOAD(UniversityImageUpload_Form, ImageType));
    } else {
      setError([Form_Check]);
    }
  };

  //-----------------------------------------------------------------//

  const handleFormReset = () => {
    setUniversityImageUpload_Form({
      ...UniversityImageUpload_Form,
      universityfile: "",
    });

    setImageType("");
    setError([]);
  };

  useEffect(() => {
    setUniversity_List(UniversityList);
  }, [UniversityList]);

  //-----------------------------------------------------------------//

  useEffect(() => {
    if (Upload_University_Images_Error) {
      setError([Upload_University_Images_Error]);
    }
    if (Upload_University_Images_Success) {
      document.getElementById("fileControl").value = "";
      setError([Upload_University_Images_Success]);
      dispatch(
        UNIVERSITY_IMAGE_DETAILS_AC_UNIVERSITY(
          UniversityImageUpload_Form.University_Id
        )
      );
      setTimeout(() => {
        handleFormReset();
      }, 3000);
    }
    setTimeout(() => {
      if (Upload_University_Images_Error || Upload_University_Images_Success) {
        dispatch(UNIVERSITY_IMAGE_UPLOAD_RESET());
      }
    }, 3000);
  }, [Upload_University_Images_Success, Upload_University_Images_Error]);

  //-----------------------------------------------------------------//

  useEffect(() => {
    if (University_Image_Ac_Type_Error) {
      setError([University_Image_Ac_Type_Error]);
      setTimeout(() => {
        dispatch(UNIVERSITY_IMAGE_DETAILS_AC_UNIVERSITY_RESET());
      }, 3000);
    }
    if (university_list_Error) {
      setError([university_list_Error]);
    }
  }, [University_Image_Ac_Type_Error, university_list_Error]);

  //-----------------------------------------------------------------//

  useEffect(() => {
    dispatch(UNIVERSITY_IMAGE_DETAILS_AC_UNIVERSITY_RESET());
  }, []);

  return (
    <>
      <Header Page={"University Image Upload"} handleHide={handleHide} />
      {/*<!-- top-right search bar -->*/}
      <SidePanel handleHide={handleHide} hide={hideSidepanel} />
      {/*<!-- Pushable content along with off-canvas opener. -->*/}
      <div className="bs-offset-main bs-canvas-anim">
        <div className="content-body">
          {/*<!--Body-content-->*/}
          <div className="container-fluid">
            <div className="inner-body">
              <div className="row">
                <div className="col-md-3 col-lg-2">
                  <div className="filter-in-mob-view text-right">
                    <input
                      type="text"
                      name="search"
                      placeholder="Search Contacts..."
                    />
                    <i className="fas fa-filter mob-nav-open"></i>
                  </div>
                </div>

                {Error.length > 0 &&
                  Error.map((el) => (
                    <div className="side_drawer">
                      <div
                        className={
                          Upload_University_Images_Success ? "Alert2" : "Alert3"
                        }>
                        <span onClick={() => setError([])} className="close">
                          &times;
                        </span>
                        <p>{el}</p>
                      </div>
                    </div>
                  ))}

                {/*<ContactTable /><!-- Contact Table -->*/}
              </div>
            </div>
            <div className="University_Image">
              <div className="Image_Uploader">
                <h4>UNIVERSITY IMAGE UPLOAD</h4>
                <div className="contact-body modify-create-contact">
                  <form onSubmit={handleFormSubmit}>
                    <div className="form-group">
                      <label>
                        Image Type:<b>*</b>
                      </label>
                      <select
                        className="form-control"
                        value={ImageType}
                        name="ImageType"
                        onChange={(e) => setImageType(e.target.value)}>
                        <option value="">Select Image Type</option>
                        <option value="Banner402x300">Banner 402X300</option>
                        <option value="Banner1903x550">Banner 1903X550</option>
                        <option value="Logo74x74">Logo 74X74</option>
                        <option value="Logo134x64">Logo 134X64</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label>
                        University:<b>*</b>
                      </label>
                      <select
                        className="form-control"
                        value={UniversityImageUpload_Form.University_Id}
                        name="University_Id"
                        onChange={handleChange}>
                        <option value="">Select University</option>
                        {University_List?.map((el) => (
                          <option
                            key={el.University_Id}
                            value={el.University_Id}>
                            {el.University_Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>
                        Upload:<b>*</b>
                      </label>
                      <input
                        id="fileControl"
                        name="universityfile"
                        onChange={handleChange}
                        type="file"
                        className="form-control"
                      />
                    </div>
                    <div className="university_Image_btn ">
                      <button
                        type="submit"
                        className="btn"
                        disabled={Upload_University_Images_Loading}>
                        {Upload_University_Images_Loading
                          ? "Loading..."
                          : "Save"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>

              <div className="Image_Uploader2">
                <h4>UPLOADED IMAGES</h4>
                {University_Image_Ac_Type_Loading ? (
                  <div className="sub_Loading">
                    <img
                      src="./assets/img/SE-loading.png"
                      className="mylogo"
                      alt="imag"
                    />
                  </div>
                ) : (
                  <div>
                    <div>
                      <p>Banner 402X300 :</p>
                      <p>
                        {University_Image_Ac_Type &&
                        University_Image_Ac_Type[0].Banner402x300 ? (
                          <a
                            href={`${process.env.REACT_APP_DOC_URL}/university/Banner402x300/${University_Image_Ac_Type[0].Banner402x300}`}
                            target="_blank">
                            {University_Image_Ac_Type[0].Banner402x300}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </p>
                    </div>
                    <div>
                      <p>Banner 1903X550 :</p>
                      <p>
                        {" "}
                        {University_Image_Ac_Type &&
                        University_Image_Ac_Type[0].Banner1903x550 ? (
                          <a
                            href={`${process.env.REACT_APP_DOC_URL}/university/Banner1903x550/${University_Image_Ac_Type[0].Banner1903x550}`}
                            target="_blank">
                            {University_Image_Ac_Type[0].Banner1903x550}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </p>
                    </div>
                    <div>
                      <p>Logo 74X74 :</p>
                      <p>
                        {" "}
                        {University_Image_Ac_Type &&
                        University_Image_Ac_Type[0].Logo74x74 ? (
                          <a
                            href={`${process.env.REACT_APP_DOC_URL}/university/Logo74x74/${University_Image_Ac_Type[0].Logo74x74}`}
                            target="_blank">
                            {University_Image_Ac_Type[0].Logo74x74}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </p>
                    </div>
                    <div>
                      <p>Logo 134X64 :</p>
                      <p>
                        {" "}
                        {University_Image_Ac_Type &&
                        University_Image_Ac_Type[0].Logo134x64 ? (
                          <a
                            href={`${process.env.REACT_APP_DOC_URL}/university/Logo134x64/${University_Image_Ac_Type[0].Logo134x64}`}
                            target="_blank">
                            {University_Image_Ac_Type[0].Logo134x64}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/*<!--/overlay-Create-contact-->*/}
          </div>
        </div>
      </div>
    </>
  );
}
